module.exports = __webpack_public_path__ + "static/media/location.5108ac4f.svg";